// @flow
import React from "react";

import {connect} from "react-redux";
import { images } from '../../config';
import CancelRide from "./CancelRide/CancelRide";
import {
    TopBarContainer,
    TopBarElement,
} from "./TopBarStyle";
import CancelSearch from "./CancelSearch/CancelSearch";
import CurrentRequestSelectors from "../../Store/Ducks/CurrentRequest/selectors";
import Screens from "../../Store/Views/screens";
import CancelTerminalSelection from "./CancelTerminalSelection/CancelTerminalSelection";

type ConnectedProps = {
    isSearching: boolean,
    showCancel: boolean,
    showCancelTerminalSelection: boolean,
};

const TopBar = (props: ConnectedProps) => {
    return (
        <TopBarContainer>
            <TopBarElement style={{justifyContent: `flex-start`}}>
                {/*Place holder*/}
            </TopBarElement>
            <TopBarElement>
                <img src={images.partner_logo} style={{alignSelf: `center`}} alt="logo"/>
            </TopBarElement>
            <TopBarElement style={{justifyContent: `flex-end`}}>
                {props.showCancel && (<CancelRide/>)}
                {props.isSearching && (<CancelSearch/>)}
                {props.showCancelTerminalSelection && (<CancelTerminalSelection/>)}
            </TopBarElement>
        </TopBarContainer>
    );
};

const mapStateToProps = (state, props) => {
    return {
        isSearching: CurrentRequestSelectors.isSearchingAddress(state),
        showCancel: Screens.shouldShowCancelButton(state),
        showCancelTerminalSelection: Screens.shouldShowCancelTerminalSelection(state),
    };
};

export default connect(mapStateToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/Components/TopBar/TopBar.js